<template>
  <b-dropdown no-caret variant="outline-primary" class="ml-1 sort-container" right v-b-tooltip.hover="'Sort By'"
    @hide="onDropdownHide">
    <template #button-content>
      <i class="fa-solid fa-arrow-up-wide-short"></i>
    </template>
    <b-dropdown-item>
      <b-button-group>
        <b-button v-for="option in sortOptions" :key="option.value" class="sort-btn"
          :variant="sortBy === option.value ? 'primary' : 'outline-primary'"
          @click.stop="onSortChanged(option.value, sortDirection[option.value])">
          {{ option.text }}
          <feather-icon v-if="sortDirection[option.value]"
            :icon="sortDirection[option.value] === 'ASC' ? 'ArrowUpIcon' : 'ArrowDownIcon'" />
        </b-button>
      </b-button-group>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BButton, BPopover, BButtonGroup, BDropdownItem, BDropdown, VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BPopover,
    BButtonGroup,
    BDropdownItem,
    BDropdown,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    options: {
      type: Array,
      default: () => ['NAME']
    },
    initialSortOptions: {
      type: Object,
      default: () => ({ sortBy: 'NAME', sortDirection: 'ASC' })
    },
  },
  data() {
    return {
      preventClose: false,
      sortBy: this.initialSortOptions.sortBy,
      sortDirection: {
        NAME: this.initialSortOptions.sortBy === 'NAME' ? this.initialSortOptions.sortDirection : null,
        HOURS_TRACKED: this.initialSortOptions.sortBy === 'HOURS_TRACKED' ? this.initialSortOptions.sortDirection : null,
        IDLE_DURATION: this.initialSortOptions.sortBy === 'IDLE_DURATION' ? this.initialSortOptions.sortDirection : null,
        PAY_RATE: this.initialSortOptions.sortBy === 'PAY_RATE' ? this.initialSortOptions.sortDirection : null,
        BILLABLE_AMOUNT: this.initialSortOptions.sortBy === 'BILLABLE_AMOUNT' ? this.initialSortOptions.sortDirection : null,
      },
      allSortOptions: [
        { text: this.$t('Name'), value: 'NAME' },
        { text: this.$t('Hours Tracked'), value: 'HOURS_TRACKED' },
        { text: this.$t('Idle Time'), value: 'IDLE_DURATION' },
        { text: this.$t('Pay Rate'), value: 'PAY_RATE' },
        { text: this.$t('Billable Amount'), value: 'BILLABLE_AMOUNT' },
      ]
    }
  },
  computed: {
    sortOptions() {
      return this.allSortOptions.filter(option => this.options.includes(option.value))
    }
  },
  watch: {
    initialSortOptions: {
      handler(value) {
        this.clearSortDirections()
        this.sortBy = value.sortBy
        this.sortDirection[value.sortBy] = value.sortDirection
      },
      deep: true,
    }
  },
  methods: {
    onDropdownHide(bvEvent) {
      // bvEvent is BootstrapVue's event object and supports preventDefault()
      if (this.preventClose) {
        bvEvent.preventDefault()
        // reset flag so subsequent hides behave normally
        this.preventClose = false
      }
    },
    clearSortDirections() {
      this.sortDirection = {
        HOURS_TRACKED: null,
        IDLE_DURATION: null,
        NAME: null,
      }
    },
    onSortChanged(sortBy, currentDirection) {
      this.clearSortDirections()

      if (sortBy === this.sortBy) {
        this.sortDirection[sortBy] = currentDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortDirection[sortBy] = sortBy === 'NAME' ? 'ASC' : 'DESC'
        this.sortBy = sortBy
      }

      this.$emit('update:sort-options', {
        sortBy: this.sortBy,
        sortDirection: this.sortDirection[sortBy],
      })
    },
  },
}
</script>

<style lang="scss">
.sort-container {
  .dropdown-item:active,
  .dropdown-item:hover {
    background-color: transparent !important;
  }
  .btn {
    height: 38px;
  }
}
</style>